import { render } from "./Sidebar.vue?vue&type=template&id=47ea37fd&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=47ea37fd&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-47ea37fd"

export default script